import 'view/css/order.css';

import moment from 'moment';
import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExcel,
  faFileImage,
} from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { Data } from 'service/util';
import Loading from 'component/Loading';
import PopMessage from 'component/pop-msg/PopMessage';
import Protected from 'component/Protected';
import ModalScreen from 'component/ModalScreen';

import DatePicker from 'react-datepicker';
import ContactList from 'component/ContactList';

import OrderDetailModal from 'component/order/OrderDetailModal';

const OrderTable = ({ orders, showDetail }) =>
{
  const [rows, setRows] = useState([]);

  // init
  useEffect(() =>
  {
    let rows = [];
    for (let i = 0; i < orders.length; i++)
    {
      let rowgrp = [];

      // copy data
      let o = orders[i];
      let total = o.items.reduce(
        (r,i) => r + (i.qty * i.unit_price - i.discount)
      , 0);

      let row1st = {
        ...o
        ,total
        ,rowSpan: o.items.length
      };

      // copy first item
      if (o.items[0])
      {
        let {
          srv_grp, grp_name, item_id, srv_name, delivery_dtm,
          unit_price, qty, discount
        } = o.items[0];
        Object.assign(row1st, {
          srv_grp, grp_name, item_id, srv_name, delivery_dtm,
          unit_price, qty, discount
        });

        // push first row
        rowgrp.push(row1st);
      }

      // create items rows
      for (let j = 1; j < o.items.length; j++)
      {
        let {
          srv_grp, grp_name, item_id, srv_name, delivery_dtm,
          unit_price, qty, discount
        } = o.items[j];
        let row2nd = {
          srv_grp, grp_name, item_id, srv_name, delivery_dtm,
          unit_price, qty, discount
        };
        Object.assign(row2nd, {
          srv_grp, grp_name, item_id, srv_name, delivery_dtm,
          unit_price, qty, discount
        });
        rowgrp.push(row2nd);
      } // level 2

      rows.push(rowgrp);
      // level 1
    }
    setRows(rows);
  }, [orders]);

  if (!orders?.length) return (
    <p className="message red">沒有任何記錄。</p>
  );

  return (
    <table className="table">
      <colgroup>
        <col width="26px" id="col-ordls-btn" />
        <col width="auto" id="col-ordls-company" />
        <col width="auto" id="col-ordls-cust" />
        <col width="auto" id="col-ordls-contact" />
        <col width="auto" id="col-ordls-license" />
        <col width="auto" id="col-ordls-order-date" />
        <col width="auto" id="col-ordls-item-name" />
        <col width="auto" id="col-ordls-item-name" />
        <col width="auto" id="col-ordls-item-delivery-date" />
        <col width="auto" id="col-ordls-item-qty" />
        <col width="auto" id="col-ordls-item-discount" />
        <col width="auto" id="col-ordls-total" />
        <col width="auto" id="col-ordls-create-date" />
        <col width="auto" id="col-ordls-mod-by" />
      </colgroup>
      <thead>
        <tr>
          <th className="col-ordls-btn"></th>
          <th className="col-ordls-cust">公司</th>
          <th className="col-ordls-cust">客戶名稱</th>
          <th className="col-ordls-contact">聯絡方法</th>
          <th className="col-ordls-license">車牌</th>
          <th className="col-ordls-order-date">下單日期</th>
          <th className="col-ordls-item-name">項目</th>
          <th className="col-ordls-item-delivery-date">送遞日期</th>
          <th className="col-ordls-item-unit-price">單價</th>
          <th className="col-ordls-item-qty">數量</th>
          <th className="col-ordls-item-discount">折扣</th>
          <th className="col-ordls-total">總額</th>
          <th className="col-ordls-pay-type">付款模式</th>
          <th className="col-ordls-status">訂單狀態</th>
          <th className="col-ordls-create-date">建立日期</th>
          <th className="col-ordls-mod-by">負責同事</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((rowgrp, ix) =>
          <div key={ix} className="content-row">
          { rowgrp.map(o =>
            <tr key={o.id}>
              { !!o.rowSpan &&
                <>
                <td rowSpan={o.rowSpan} className="col-ordls-btn" onClick={e=>showDetail(o)}>
                  <FontAwesomeIcon icon={faFileImage} />
                </td>
                <td rowSpan={o.rowSpan} className="col-ordls-company">{Util.getCompanyName(o.company)}</td>
                <td rowSpan={o.rowSpan} className="col-ordls-cust">{o.cust_name} ({o.cust_id})</td>
                <td rowSpan={o.rowSpan} className="col-ordls-contact">
                  <ContactList contacts={ o.contacts } />
                </td>
                <td rowSpan={o.rowSpan} className="col-ordls-license">{o.cd_license}</td>
                <td rowSpan={o.rowSpan} className="col-ordls-order-date">{Util.ShortDate(o.order_dtm)}</td>
                </>
              }
              <td className="col-ordls-item-name" title={`${o.item_id} - ${o.srv_name}`}>{o.srv_name}</td>
              <td className="col-ordls-item-delivery-date">{ Util.ShortDate(o.delivery_dtm) }</td>
              <td className="col-ordls-item-unit-price">{ !!o.unit_price && '$' + Util.nf(o.unit_price)}</td>
              <td className="col-ordls-item-qty">{o.qty}</td>
              <td className="col-ordls-item-discount">{ !!o.discount && '$' + Util.nf(o.discount)}</td>
              { !!o.rowSpan &&
                <>
                <td rowSpan={o.rowSpan} className="col-ordls-total">{!!o.total && '$' + Util.nf(o.total)}</td>
                <td rowSpan={o.rowSpan} className="col-ordls-pay-type">{ Util.getPaymentType(o.payment_type) }</td>
                <td rowSpan={o.rowSpan} className="col-ordls-status">{ Util.getOrderStatus(o.o_status) }</td>
                <td rowSpan={o.rowSpan} className="col-ordls-create-date">{ Util.FullDate(o.create_dtm) }</td>
                <td rowSpan={o.rowSpan} className="col-ordls-mod-by">{o.mod_by}</td>
                </>
              }
            </tr>
          )}
          </div>
        )}
      </tbody>
    </table>
  );

}

//==============================================================================================

const OrderView = (props) =>
{
  const [exporting, setExporting] = useState(false);

  const [loading,  setLoading ] = useState(false);
  const [date_typ, setDateType] = useState('delivery');
  const [sel_from, setFromDate] = useState(new Date());
  const [sel_to,   setToDate  ] = useState(new Date());

  const [filter,   setFilter  ] = useState({
     prod_grp: null
    ,prod_id: null
    ,pay_opt: ''
    ,o_status: ''
  });

  const [data,     setData    ] = useState(null);
  const [orders,   setOrders  ] = useState([]);

  const [ls_srvGrp, setServiceGroups] = useState(null);
  const [ls_srvItm, setServiceItems]  = useState(null);

  const [modal, setModal] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  const refreshData = () =>
  {
    // check range limit
    if ( moment(sel_to).diff(sel_from, 'days') >= 366 )
    {
      PopMessage.show('日期範圍不能超過366天。', '操作失敗', 'danger');
      return false;
    }

    // close all modal
    setModal(null);
    // show loading
    setLoading(true);

    // create param DTO
    let dto = {
       date_typ
      ,from_dtm: sel_from
      ,to_dtm: sel_to
    };

    API.getOrdersByFilter(dto).then(resp =>
    {
      if (resp.success) {
        setData(resp.msg);
        refreshDropdown(resp.msg);
      } else {
        PopMessage.show(resp.msg, '讀取失敗', 'danger');
      }
      setLoading(false);
    });
  }

  const refreshDropdown = (apiData) =>
  {
    let _ls_ord = apiData || data;
    if (!_ls_ord) {
      setServiceGroups(null);
      setServiceItems(null);
      return;
    }

    let dict_grp = {};
    let dict_itm = {};
    for (let oi = 0; oi < _ls_ord.length; oi++)
    for (let ii = 0; ii < _ls_ord[oi].items.length; ii++)
    {
      let { srv_grp, grp_name, item_id, srv_name } = _ls_ord[oi].items[ii];
      if (!(srv_grp in dict_grp)) dict_grp[srv_grp] = { id: srv_grp, name: grp_name };

      if (!filter.prod_grp && filter.prod_grp == srv_grp) {
        if (!(item_id in dict_itm)) dict_itm[item_id] = { id: item_id, name: srv_name };
      }
    }
    setServiceGroups(Object.values(dict_grp));
    setServiceItems(Object.values(dict_itm));

  }

  const refreshFilter = () =>
  {
    if (!data) {
      setOrders([]);
      return;
    }

    let _ord = data;
    if (filter.prod_grp) {
      _ord = _ord.filter(o => o.items.some(
        i => i.srv_grp == filter.prod_grp
      ));
    }

    if(filter.prod_id) {
      _ord = _ord.filter(o => o.items.some(
        i => i.id == filter.prod_id
      ));
    }

    if (filter.o_status) {
      _ord = _ord.filter(o => o.o_status == filter.o_status);
    }

    if (filter.pay_opt) {
      switch (filter.pay_opt)
      {
        case '-':
          _ord = _ord.filter(o => o.payment_type == '0');
          break;
        case '+':
          _ord = _ord.filter(o => o.payment_type != '0');
          break;
        default:
          _ord = _ord.filter(o => o.payment_type == filter.pay_opt);
          break;
      }
    }

    setOrders(_ord);
  }

  const showDetail = (order) =>
  {
    let modal = <OrderDetailModal order={order} refreshData={refreshData} />
    setModal(modal);
    setModalTitle(`訂單 - ${order.ix_yrmo}-${Util.LPAD(order.id,7)}`);
  }

  const exportXls = () =>
  {
    setExporting(true);

    let dto = { ...filter, date_typ, from_dtm: sel_from, to_dtm: sel_to };
    dto.pay_opt  = dto.pay_opt  || null;
    dto.o_status = dto.o_status || null;

    API.exportOrder(dto).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `${Util.ShortDate(sel_from)}-${Util.ShortDate(sel_to)} 訂單紀錄_${ix_date}.xlsx`);
      setExporting(false);
    });
  }

  //----------------------------------------------
  // init
  useEffect(() => {
    if ( moment(sel_from).isAfter(sel_to) ) {
      setToDate(sel_from);
    }
    refreshData();
  }, [date_typ, sel_from, sel_to]);

  useEffect(() => {
    refreshDropdown();
    refreshFilter();
  }, [data, filter]);

  return (<>
    <h1>日常操作 - 訂單</h1>
    <div className="row action-panel">
      <div className="row search-bar">
        <label className="search-field">
          <strong>搜索</strong>
          <select value={date_typ} onChange={e=>setDateType(e.target.value)}>
            <option value="delivery">送遞</option>
            <option value="order">下單</option>
            <option value="creation">建立</option>
          </select>
        </label>
        <label className="search-field">
          <strong>日期由</strong>
          <DatePicker selected={sel_from}
            onChange={setFromDate}
            dateFormat="dd-MM-yyyy"
          />
        </label>
        <label className="field-row">
          <strong>至</strong>
          <DatePicker selected={sel_to}
            minDate={ sel_from }
            onChange={setToDate}
            dateFormat="dd-MM-yyyy"
          />
        </label>
        { !!data?.length && !!ls_srvGrp &&
          <label className="field-row">
            <strong>分類</strong>
            <select value={filter.prod_grp}
              onChange={e=>setFilter({...filter, prod_grp: parseInt(e.target.value,10)})}>
              <option value="">全部</option>
              { ls_srvGrp.map(g =>
                <option key={g.id} value={g.id}>{g.name}</option>
              )}
            </select>
          </label>
        }
        { !!data?.length && !!ls_srvItm &&
          <label className="field-row">
            <strong>服務/商品</strong>
            <select value={filter.prod_id}
              onChange={e=>setFilter({...filter, prod_id: parseInt(e.target.value,10)})}>
              <option value="">全部</option>
              { ls_srvItm.map(i =>
                <option key={i.id} value={i.id}>{i.name}</option>
              )}
            </select>
          </label>
        }
        <label className="field-row">
          <strong>付款狀態</strong>
          <select value={filter.pay_opt}
            onChange={e=>setFilter({...filter, pay_opt: e.target.value})}>
            <option value="">全部</option>
            <option value="-">未付款</option>
            <option value="+">已付款</option>
            <option value="C">現金</option>
            <option value="T">轉賬</option>
            <option value="Q">支票</option>
          </select>
        </label>
        <label className="field-row">
          <strong>訂單狀態</strong>
          <select value={filter.o_status}
            onChange={e=>setFilter({...filter, o_status: e.target.value})}>
            <option value="">全部</option>
            <option value={0}>新訂單</option>
            <option value={1}>消取</option>
            <option value={2}>拒絕</option>
            <option value={8}>暫緩</option>
            <option value={9}>跟進</option>
            <option value={10}>處理中</option>
            <option value={11}>送遞中</option>
            <option value={12}>已送遞</option>
          </select>
        </label>
      </div>
      <div>
        <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
          <button className="btn dark-green btn-export" onClick={exportXls}>
            <FontAwesomeIcon icon={faFileExcel} />
            <span> 匯出</span>
          </button>
        </Protected>
      </div>
    </div>
    <div className="order-table">
      { loading
        ?<Loading />
        :<OrderTable orders={orders} showDetail={showDetail} />
      }
    </div>
    <ModalScreen show={!!modal} title={modalTitle} onClose={e=>setModal(null)}>
      { modal }
    </ModalScreen>
  </>);


}

export default OrderView;